import { publicBaseUrl, releaseVersion, webappTarget } from './env';

const appConfigs = {
  admin: {
    appName: process.env.REACT_APP_APP_NAME || '',
    browserTitle: process.env.REACT_APP_BROWSER_TITLE || '',
    loginTitle: process.env.REACT_APP_LOGIN_TITLE || '',
    loginSubtitle: process.env.REACT_APP_LOGIN_SUBTITLE || '',
    homeUrl: process.env.REACT_APP_HOME_URL || publicBaseUrl || '/admin',
    releaseVersion,
  },
  student: {
    appName: process.env.REACT_APP_APP_NAME || '',
    browserTitle: process.env.REACT_APP_BROWSER_TITLE || '',
    loginTitle: process.env.REACT_APP_LOGIN_TITLE || '',
    loginSubtitle: process.env.REACT_APP_LOGIN_SUBTITLE || '',
    homeUrl: process.env.REACT_APP_HOME_URL || publicBaseUrl || '/home',
    releaseVersion,
  },
  portal: {
    appName: process.env.REACT_APP_APP_NAME || '',
    browserTitle: process.env.REACT_APP_BROWSER_TITLE || '',
    loginTitle: process.env.REACT_APP_LOGIN_TITLE || '',
    loginSubtitle: process.env.REACT_APP_LOGIN_SUBTITLE || '',
    homeUrl: process.env.REACT_APP_HOME_URL || publicBaseUrl || '/',
    releaseVersion,
  },
  subscription: {
    appName: process.env.REACT_APP_APP_NAME || '',
    browserTitle: process.env.REACT_APP_BROWSER_TITLE || '',
    loginTitle: process.env.REACT_APP_LOGIN_TITLE || '',
    loginSubtitle: process.env.REACT_APP_LOGIN_SUBTITLE || '',
    homeUrl: process.env.REACT_APP_HOME_URL || publicBaseUrl || '/subscription',
    releaseVersion,
  },
};

export const appConfig = appConfigs[webappTarget] || appConfigs.portal;
